import { Button, Modal, Switch } from "antd";
import TabSelector from "pages/dashboard/audioLibrary/components/tabSelector";
import {
  getCamerasBySite,
  savePanoramaSettings,
} from "pages/dashboard/customers/service";
import { useCommonService } from "pages/service";
import { useEffect, useMemo, useState } from "react";
import { SvgLogo, SvgPanoramaCamera } from "ui/svgs";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Panorama from "pages/dashboard/streaming/components/panorama";
import { showToast } from "ui/components/common";
import "./panoramaEdit.scss";
function Footer({ valid, onClose, onConfirm, loading }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        width: "100%",
        marginTop: "24px",
      }}
    >
      <div className="primaryButton bordered" onClick={onClose}>
        Cancel
      </div>
      <Button
        loading={loading}
        onClick={onConfirm}
        disabled={!valid}
        className={valid ? "primaryButton" : "primaryButton disabled"}
        style={{ marginLeft: "12px" }}
      >
        Confirm
      </Button>
    </div>
  );
}
// candidate cameras
function CameraItem({ camera, cameraPositions }) {
  const { takeSnapshot } = useCommonService();
  const [source, setSource] = useState(null);
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    const match = cameraPositions.find((item) => item?.id === camera?.id);
    if (match) setDisabled(true);
    else setDisabled(false);
  }, [cameraPositions]);
  const [_, drag] = useDrag(
    () => ({
      item: camera,
      type: "camera",
      canDrag: !disabled,
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [disabled],
  );
  useEffect(() => {
    const cameras = [
      {
        macAddress: camera.macAddress,
        id: camera.id,
        remoteIndex: camera.remoteIndex,
        streamId: camera?.capabilities?.streamNum > 1 ? 1 : 0,
      },
    ];
    takeSnapshot(camera.nvrId, cameras, camera.orgId, (data) => {
      const i = data.findIndex((item) => item?.id === camera.id);
      if (i >= 0 && data[i]?.blob) {
        console.log("res  candidate cameras", camera.id, i);
        setSource(URL.createObjectURL(data[i]?.blob));
      }
    });
  }, [camera]);
  return (
    <div>
      <div ref={drag} style={{ position: "relative" }}>
        {!disabled ? null : (
          <div
            style={{
              height: "100%",
              width: "100%",
              zIndex: "1",
              position: "absolute",
              backgroundColor: "rgba(238, 238, 238, 0.5)",
              cursor: "not-allowed",
            }}
          ></div>
        )}
        {source ? (
          <img
            className="aspect-video"
            src={source}
            style={{ width: "160px", height: "90px", borderRadius: "8px" }}
          />
        ) : (
          <div
            style={{
              width: "160px",
              height: "90px",
              borderRadius: "8px",
              alignContent: "center",
              textAlign: "center",
              backgroundColor: "rgba(238, 238, 238, 1)",
            }}
          >
            <SvgLogo width="28" className="fill-zinc-400 inline-block" />
          </div>
        )}
      </div>
      <div style={{ textAlign: "left", fontSize: "16px", width: "160px" }}>
        {camera.name}
      </div>
    </div>
  );
}
//panorama cameras
function CameraPosition({ order, onSetPosition, camera }) {
  const { takeSnapshot } = useCommonService();
  const [source, setSource] = useState(null);
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: "camera",
      canDrop: () => true,
      drop: (item) => onSetPosition(order, item),
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [],
  );
  const [_, drag] = useDrag(
    () => ({
      item: camera,
      type: "camera",
      canDrag: !!camera?.id,
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [camera],
  );
  useEffect(() => {
    if (!camera) return;
    setSource(null);
    const cameras = [
      {
        macAddress: camera.macAddress,
        id: camera.id,
        remoteIndex: camera.remoteIndex,
        streamId: camera?.capabilities?.streamNum > 1 ? 1 : 0,
      },
    ];

    takeSnapshot(camera.nvrId, cameras, camera.orgId, (data) => {
      const i = data.findIndex((item) => item?.id === camera.id);
      if (i >= 0 && data[i]?.blob) {
        setSource(URL.createObjectURL(data[i]?.blob));
      }
    });
  }, [camera]);
  return (
    <div
      ref={drop}
      className="aspect-video"
      style={{
        flex: 1,
        border: camera ? "none" : "2px dashed rgba(189, 189, 189, 1)",
        alignContent: "center",
        textAlign: "center",
        backgroundColor: isOver ? "rgba(238, 238, 238, 1)" : "transparent",
      }}
    >
      {camera ? (
        <div ref={drag}>
          {source ? (
            <img className="aspect-video" src={source} />
          ) : (
            <div
              className="aspect-video"
              style={{
                alignContent: "center",
                textAlign: "center",
                backgroundColor: "rgba(238, 238, 238, 1)",
              }}
            >
              <SvgLogo width="28" className="fill-zinc-400 inline-block" />
            </div>
          )}
        </div>
      ) : (
        <SvgPanoramaCamera />
      )}
    </div>
  );
}
export default function PanoramaEditModal({ onClose, visible, site }) {
  const [loading, setLoading] = useState(false);
  const [enablePanorama, setEnablePanorama] = useState(false);
  const [cameraNumber, setCameraNumber] = useState("3");
  const [cameraList, setCameraList] = useState([]);
  const [panoramaPreview, setPanoramaPreview] = useState(false);
  const [cameraPositions, setCameraPositions] = useState(
    Array.from({ length: 4 }),
  );
  const valid = useMemo(() => {
    const filtered = cameraPositions.filter((item: any) => !!item?.id);
    return filtered.length >= parseInt(cameraNumber);
  }, [cameraPositions, cameraNumber]);
  async function onConfirm() {
    setLoading(true);
    const _cameraPositions = cameraPositions.filter((item: any) => !!item?.id);
    try {
      const res = await savePanoramaSettings(
        site.id,
        {
          enabled: enablePanorama,
          panoramas: [
            {
              cameras: _cameraPositions
                .map((item: any, index) => ({
                  id: item.id,
                  index,
                }))
                .slice(0, parseInt(cameraNumber)),
              num: parseInt(cameraNumber),
            },
          ],
        },
        site.orgId,
      );
      if (res.status === 200) {
        showToast(0, "Panorama settings saved successfully");
        onClose();
        window.location.reload();
      } else {
        showToast(1, "Failed to save Panorama settings");
      }
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (!visible) return;
    setEnablePanorama(site.panorama?.enabled);
    setCameraNumber(site.panorama?.panoramas?.[0]?.num?.toString() || "3");
    getCamerasBySite(site.id, site.orgId).then((data) => {
      setCameraList(data.data.data);
      //get camera details from cameraList with panorama cameras
      site.panorama?.panoramas?.[0]?.cameras.map((camera) => {
        const match = data.data.data.find((item) => item.id === camera.id);
        if (match) {
          setCameraPositions((state) => {
            state[camera.index] = match;
            return [...state];
          });
        }
      });
      // setCameraPositions(
      //   data.data.data.filter((item) => {
      //     const match = site.panorama?.panoramas?.[0]?.cameras.find(
      //       (camera) => camera.id === item?.id,
      //     );
      //     return match;
      //   }),
      // );
    });
  }, [visible]);
  return (
    <>
      <Modal
        open={visible}
        width={720}
        footer={
          <Footer
            onClose={onClose}
            onConfirm={onConfirm}
            valid={valid}
            loading={loading}
          />
        }
        onCancel={onClose}
        title="Panorama Settings"
      >
        <DndProvider backend={HTML5Backend}>
          <div style={{ marginBottom: "12px" }}>
            <span style={{ marginRight: "12px", fontSize: "16px" }}>
              Enable Panorama View
            </span>
            <Switch value={enablePanorama} onChange={setEnablePanorama} />
          </div>

          <TabSelector
            options={[
              { label: "3 Cameras", value: "3" },
              { label: "4 Cameras", value: "4" },
            ]}
            value={cameraNumber}
            onChange={setCameraNumber}
          />

          <div style={{ fontSize: "16px", marginBottom: "12px" }}>
            Drag Camera Here
          </div>
          <div style={{ display: "flex", gap: "5px" }}>
            {Array.from({ length: parseInt(cameraNumber) }).map((_, index) => {
              return (
                <CameraPosition
                  key={index}
                  order={index}
                  camera={cameraPositions[index]}
                  onSetPosition={(order, camera) => {
                    setCameraPositions((state) => {
                      const index = state.findIndex(
                        (item: any) => item?.id === camera.id,
                      );
                      if (index !== -1) {
                        const _temp = state[order];
                        state[order] = camera;
                        state[index] = _temp;
                      } else {
                        state[order] = camera;
                      }
                      return [...state];
                    });
                  }}
                />
              );
            })}
          </div>

          <Button
            className="primaryButton"
            style={{ width: "200px", margin: "12px auto", display: "block" }}
            disabled={!valid}
            onClick={() => {
              setPanoramaPreview(true);
            }}
          >
            Preview
          </Button>
          <div style={{ fontSize: "16px", marginBottom: "12px" }}>
            Available Cameras
          </div>
          <div
            style={{
              height: "240px",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "5px",
              overflow: "auto",
            }}
          >
            {cameraList.map((item, index) => {
              return (
                <CameraItem
                  camera={item}
                  key={index}
                  cameraPositions={cameraPositions}
                />
              );
            })}
          </div>
        </DndProvider>
      </Modal>
      <Panorama
        visible={panoramaPreview}
        cameras={cameraPositions.filter((item: any) => item?.id)}
        onClose={() => {
          setPanoramaPreview(false);
        }}
      />
    </>
  );
}
